import React from "react";
import { History } from "history";
import { IActionLink, Icon, IconName } from "halifax";
import { ActivitiesEntryTypeEnum, ItineraryEnum } from "redmond";
import {
  PATH_ACTIVITIES_AVAILABILITY,
  getExperiencesAvailabilityQuery,
} from "@capone/common";

import { fetchActivityLocationByCoordinates } from "../api/v1/search/fetchActivityLocationByCoordinates";

export interface BuildExploreActivitiesActionsArgs {
  cityLabel: string;
  fallbackLabel: string;
  coords?: { lat: number; lon: number };
  fromDate: string | Date | null;
  untilDate?: string | Date | null;
  isTravelApp?: boolean;
  history: History;
  product?: ItineraryEnum;
}

export const buildExploreActivitiesActions = ({
  cityLabel,
  fallbackLabel,
  coords,
  fromDate,
  untilDate,
  isTravelApp,
  history,
  product,
}: BuildExploreActivitiesActionsArgs): IActionLink[] => [
    {
      content: product === ItineraryEnum.Experience ? `Explore more activities` : `Explore activities in ${cityLabel}`,
      onClick: async () => {
        let locationLabel = fallbackLabel;
        if (coords) {
          try {
            const res = await fetchActivityLocationByCoordinates(coords.lat, coords.lon);
            const resolved = res.categories[0]?.results[0]?.label;
            if (resolved) locationLabel = resolved;
          } catch {
            // keep fallbackLabel
          }
        }
        const entryType = product === ItineraryEnum.Flight ? ActivitiesEntryTypeEnum.MYTRIPS_XSELL_FLIGHT : (product === ItineraryEnum.Hotel || product === ItineraryEnum.Home) ? ActivitiesEntryTypeEnum.MYTRIPS_XSELL_STAY : product === ItineraryEnum.Experience ? ActivitiesEntryTypeEnum.MYTRIPS_XSELL_ACTIVITY : ActivitiesEntryTypeEnum.MYTRIPS_XSELL
        if (locationLabel) {
          history.push(
            `${PATH_ACTIVITIES_AVAILABILITY}${getExperiencesAvailabilityQuery(
              locationLabel,
              fromDate,
              untilDate,
              undefined,
              isTravelApp,
              entryType,
            )}`,
          );
        }
      },
      showAsButton: true,
      icon: <Icon name={IconName.ExperiencesIcon} />,
    },
  ];
